import React from 'react';
import { useField } from 'formik';
import bem from 'utils/bem';
import FormError from 'forms/fields/FormError';

import './index.sass'

const { cnBlock } = bem('form-field', 'form-textarea');

export default ({ className, name, ...props }) => {

    const [field, meta] = useField({ name, type: 'text' });

    return <div className={cnBlock(className, { 'invalid': meta.error && meta.touched})}>
        <textarea
            {...field}
            {...props}
        />
        {meta.error && meta.touched && <FormError>{meta.error}</FormError>}
    </div>

}
